import {Injectable} from "@angular/core";
import {ComponentStore} from "@ngrx/component-store";
import {AppState} from "../../store/store";
import {Store} from "@ngrx/store";


@Injectable()
export class NotificationsStore extends ComponentStore<any> {
  constructor(
    private readonly _store: Store<AppState>
  ) {
    super({
      loading: false
    });
  }
}
